import { CommonResponse, post } from './common.ts'

// POST /contact/brief
interface PostContactBriefRequest {
  company: string // 20
  name: string // 20
  phone: string // 20
  email: string // 50
  service: string // 200
  message: string // 500
  reference: string // 200
  budget: string // 100
  date: string // 50
}
interface PostContactBriefFile {
  file: File | null
}

export const postContactBrief = async (
  data: PostContactBriefRequest,
  fileData: PostContactBriefFile
): Promise<CommonResponse<null>> => {
  let form = new FormData()
  form.append('company', data.company)
  form.append('name', data.name)
  form.append('phone', data.phone)
  form.append('email', data.email)
  form.append('service', data.service)
  form.append('message', data.message)
  form.append('reference', data.reference)
  form.append('budget', data.budget)
  form.append('date', data.date)
  form.append('file', fileData.file)
  return await post('/contact/brief', form)
}

// POST /contact/minute
interface PostContactMinuteRequest {
  service: string // 20
  prevService: string // 20
  payment: string // 20
  generalPayment: string // 50
  easyPayment: string // 50
  pointPayment: string // 20
  register: string // 20
  socialRegister: string // 20
  delivery: string // 20
  notice: string // 50
  etcService: string // 200
  message: string // 500
  company: string // 20
  name: string // 20
  phone: string // 20
  email: string // 50
  budget: string // 100
  reference: string // 200
  etcTechMessage: string // 500
}

export const postContactMinute = async (
  data: PostContactMinuteRequest
): Promise<CommonResponse<null>> => {
  console.log(data)
  return await post('/contact/minute', data)
}

// POST /contact/hugcare
interface PostContactHugcareRequest {
  company: string // 20
  name: string // 20
  phone: string // 20
  email: string // 50
}

export const postContactHugcare = async (
  data: PostContactHugcareRequest
): Promise<CommonResponse<null>> => {
  return await post('/contact/hugcare', data)
}
